import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserCollectionSelectorModule } from '@features/collections/user-collection-selector/user-collection-selector.module';
import { IconsModule } from '@features/icons/icons.module';
import { FoundationModule } from '../../../fundament/foundation/foundation.module';
import { NavbarComponent } from './navbar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    IconsModule,
    UserCollectionSelectorModule,
    FoundationModule,
  ],
  declarations: [NavbarComponent],
  exports: [NavbarComponent],
})
export class NavbarModule {}
